// extracted by mini-css-extract-plugin
module.exports = {"media":"editorial-element-plp_media__3YazI","maxContentMobile":"editorial-element-plp_maxContentMobile__asaiz","maxContentDesktop":"editorial-element-plp_maxContentDesktop__7XrVh"};